<template>
  <div class="modal fade" id="upload-csv-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content">
        <div class="modal-header" v-html="header"></div>
        <div class="modal-body">
          <p v-if="title" class="font-bold">{{ title }}</p>
          <div class="mr-b-10">
            <button class="btn btn-primary" @click="handleDownloadTemplate">
              {{ btnDownloadText }}
              <i class="fa fa-download" aria-hidden="true"></i>
            </button>
          </div>
          <div v-if="needProductId">
            ※「商品ID」:
            <div v-for="item in settingProductIdOptions" :key="item" class="radio-inline">
              <input type="radio" :value="item" name="filter-judgment-status" :id="`radio-` + item" v-model="selectedSettingProductId" @change="settingProductId()">
              <label class="input-label" :for="`radio-${item}`">{{ item }}</label>
            </div>
          </div>
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :options="this.option"
            @vdropzone-success="handleSuccess"
            @vdropzone-file-added="handleFileAdded"
            @vdropzone-removed-file="handleRemovedFile"
          >
          </vue-dropzone>
        </div>
        <div class="modal-footer">
          <button class="btn btn-warning" :disabled="isDisabledUpload" @click="updateFiles">{{ btnUploadText }}</button>
          <button class="btn" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import * as code from '@/common/code'

export default {
  props: {
    header: {
      type: String,
      default: `<div>
        セラー様 → ACROSS倉庫へ納品する商品・数量をアップロードしてください
      </div>`
    },
    title: {
      type: String,
      default: ''
    },
    btnDownloadText: {
      type: String,
      default: 'テンプレートをダウンロード'
    },
    btnSelectText: {
      type: String,
      default: 'またはファイルを選択'
    },
    btnUploadText: {
      type: String,
      default: '商品を追加'
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default () {
        return {
          url: `${process.env.NODE_SERVER_API + this.uploadUrl}`,
          headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
          thumbnailWidth: 150,
          maxFilesize: 150,
          maxFiles: 1,
          acceptedFiles: 'text/csv,text/plain',
          addRemoveLinks: true,
          autoProcessQueue: false,
          dictDefaultMessage: `ファイルをここにドラッグ&ドロップ<br><br><button class="btn btn-info w-200">${this.btnSelectText}</button>`,
          dictInvalidFileType: 'この形式のファイルはアップロードできません。',
          dictMaxFilesExceeded: '複数のファイルをアップロードすることはできません。'
        }
      }
    },
    needProductId: {
      type: Boolean,
      default: false
    },
    settingProductIdOptions: {
      type: Array,
      default () {
        return ['ASIN', 'SKU', 'FNSKU']
      }
    },
    defaultSettingProductId: {
      type: String,
      default: ''
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
  },
  data () {
    return {
      loader: null,
      isDisabledUpload: true,
      selectedSettingProductId: this.defaultSettingProductId
    }
  },
  methods: {
    handleFileAdded (file) {
      const dz = this.$refs.myVueDropzone.dropzone
      if (dz.files.length > 1) {
        dz.removeFile(dz.files[0])
      }

      const allowedTypes = ['text/csv', 'text/plain']
      if (!allowedTypes.includes(file.type)) {
        this.isDisabledUpload = true
        return
      }

      this.isDisabledUpload = false
    },
    handleRemovedFile () {
      this.isDisabledUpload = true
    },
    handleSuccess (file, response) {
      if (response.header.resultCode !== code.success) {
        this.$refs.myVueDropzone.removeAllFiles()
        this.$store.commit('toggleModal', {
          show: true,
          message: response.header.message
        })
        return
      }
      this.$emit('handleUploadSuccess', response)
      this.$refs.myVueDropzone.removeAllFiles()
    },
    updateFiles () {
      if (this.isDisabledUpload) {
        return false
      }
      if (this.$refs.myVueDropzone.getQueuedFiles().length) {
        this.$refs.myVueDropzone.processQueue()
      } else {
        this.$refs.myVueDropzone.removeAllFiles()
      }
      this.$emit('handleUpload')
    },
    handleDownloadTemplate () {
      this.$emit('handleDownloadTemplate')
    },
    settingProductId () {
      if (this.needProductId) {
        const dz = this.$refs.myVueDropzone.dropzone
        dz.options.params = {
          settingProductId: this.selectedSettingProductId
        }
      }
    }
  },
  mounted () {
    $('#upload-csv-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
.modal-content {
  padding: 20px 40px;
}
.modal-header {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  padding: unset;
  border-bottom: unset;
}
.modal-body {
  padding: 20px 10px;
}
.modal-footer {
  border-top: unset;
  background-color: inherit;
}
@media (min-width: 1024px) {
  .modal-lg {
    width: 1000px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UploadCsvModal.vue